import { render, staticRenderFns } from "./CepRemoveAddressModal.vue?vue&type=template&id=2691fcc8&scoped=true&"
import script from "./CepRemoveAddressModal.vue?vue&type=script&lang=js&"
export * from "./CepRemoveAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./CepRemoveAddressModal.vue?vue&type=style&index=0&id=2691fcc8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691fcc8",
  null
  
)

export default component.exports